import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full overflow-y-auto"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6 h-full"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "ID Produk", -1)
const _hoisted_8 = { class: "my-2 text-black-lp-300" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Tipe Produk", -1)
const _hoisted_11 = { class: "my-2 text-black-lp-300 capitalize" }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "eCargo Product", -1)
const _hoisted_14 = { class: "my-2 text-black-lp-300 capitalize" }
const _hoisted_15 = { class: "py-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Deskripsi", -1)
const _hoisted_17 = { class: "my-2 text-black-lp-300 w-3/4 break-words" }
const _hoisted_18 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_19 = { class: "py-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Produk", -1)
const _hoisted_21 = { class: "my-1 text-black-lp-300" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "capitalize" }
const _hoisted_24 = { class: "py-3" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_26 = { class: "my-1 text-black-lp-300" }
const _hoisted_27 = { class: "text-gray-lp-500" }
const _hoisted_28 = { class: "py-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_30 = { class: "my-1 text-black-lp-300" }
const _hoisted_31 = { class: "text-gray-lp-500" }
const _hoisted_32 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading === true)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.dataDetail.name), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchProductData
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.dataDetail.id), 1)
                ]),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.dataDetail.name), 1)
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.dataDetail.eCargoProduct), 1)
                ]),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.dataDetail.description), 1)
                ])
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, [
                        _createVNode("span", _hoisted_23, _toDisplayString(_ctx.dataDetail.status.toLowerCase()), 1)
                      ], 2)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.createdAt), 1),
                  _createVNode("div", _hoisted_27, _toDisplayString(_ctx.createdBy), 1)
                ]),
                _createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, _toDisplayString(_ctx.updateAt), 1),
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.updateBy), 1)
                ]),
                _createVNode("div", _hoisted_32, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = () => _ctx.goEdit(_ctx.id)),
                        title: "Edit",
                        class: "px-8 bg-red-lp-300"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]))
}